import React, { useEffect, useState } from "react";
//import { storeConfig } from '../../config/config';
import { DialogflowQueryType } from "../models/enum";
import "./store-selector-detail.scss";
import "../message/message.scss";
import { postMessageToClient } from "../chatservice/communicationService";
import { getStoreStatus } from "../util/commonUtil";
type StoreSelectorDetailProps = {
  store: any;
  isHostDevice: boolean;
  setStore: any;
  quickReplyHandler: any;
  setSelectedStoreData: any;
};

const StoreSelectorDetail = ({
  store,
  isHostDevice,
  setStore,
  setSelectedStoreData,
  quickReplyHandler,
}: StoreSelectorDetailProps) => {

  const [isDelivery, setIsDelivery] = useState<boolean>(
    store.data.isDeliveryEnabled
  );
  const [isPickup, setIsPickup] = useState<boolean>(
    store.data.isClickAndCollectEnabled
  );
  const [isDriveThrough, setIsDriveThrough] = useState(
    store.data.facilities.includes("Drive Thru")
  );
  const [tomorrowDay, setTomorrowDay] = useState<any>();
  const [statusBackground, setStatusBackground] = useState("");
  const [storeCurrentStatus, setStoreCurrentStatus] = useState("");
  const [storeTradingHours, setStoreTradingHours] = useState("");

  const onClickHandler = (e: any) => {
    const params: any = {
      selectedStoreId: store.data.storeId,
      selectedStoreName:
        "BWS " +
        store.data.suburb.charAt(0).toUpperCase() +
        store.data.suburb.slice(1).toLowerCase(),
    };

    if (!store.isSelected) {
      quickReplyHandler(
        e,
        DialogflowQueryType.Event,
        "PRODUCT_AVAIL_SET_STORE",
        false,
        params
      );
      store.isSelected = true;
      setStore(parseInt(store.data.storeId));
      setSelectedStoreData(store.data);
    }
  };

  useEffect(() => {
    let todayDate = new Date();
    todayDate.setDate(todayDate.getDate() + 1);
    let day = new Date(todayDate);
    let dayName = day.toString().split(" ")[0];
    setTomorrowDay(dayName);
    
    //calling a function to get store current status
    const status = getStoreStatus(store?.data);
    
    setStoreTradingHours(status?.storeTradingHours);
    setStoreCurrentStatus(status?.StoreCurrentStatus);
    setStatusBackground(status?.StatusBackground);
  }, []);
  
  return (
    <div className="storeStock">
      <div className="storeStock__location">
        <div className="storeStock__title">
          BWS{" "}
          <span className="storeStock__suburb">
            {store.data.name.toLowerCase()}
          </span>
        </div>
        {store.data.distance && (
          <div className="storeStock__distance">{store.data.distance} km</div>
        )}
      </div>

      <div className="storeStock__facilities">
        {isDelivery ? (
          <div className="delivery">
            <img
              className="product__facilities-isAvailable"
              src="/images/Vector-correct.svg"
              alt=""
            />
            <span> Delivery</span>
          </div>
        ) : (
          ""
        )}
        {isPickup ? (
          <div className="pickUp">
            <img
              className="product__facilities-isAvailable"
              src="/images/Vector-correct.svg"
              alt=""
            />
            <span> Pick up</span>
          </div>
        ) : (
          ""
        )}

        {isDriveThrough ? (
          <div className="driveThrough">
            <img
              className="product__facilities-isAvailable"
              src="/images/Vector-correct.svg"
              alt=""
            />
            <span> Drive through</span>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="storeStock__address">
        <span>
          {store.data.addressLine1}, {store.data.state} {store.data.postCode}
        </span>
      </div>

      <div className="storeStock__suburb-status">
        <div className="storeStock__status">
          <span className={"storeStock__status-today " + statusBackground}>
            {storeCurrentStatus}
          </span>
          <span>{storeTradingHours}</span>
        </div>

        <div className="storeStock__week-status">
          {store.data.trading_hours_all?.map((day: any, index: any) => {
            return (
              <div key={index}>
                {index != 0 ? (
                  index != 7 ? (
                    <div className="storeStock__trading-Hours">
                      <span className="storeStock__trading-Hours__day">
                        {day.day.slice(0, 3) === "Tom"
                          ? tomorrowDay
                          : day.day.slice(0, 3)}
                      </span>
                      <div className="storeStock__trading-Hours__date">
                        <span>
                          {new Date(day.date).toLocaleDateString("en-us", {
                            day: "numeric",
                          })}
                        </span>
                        <span>
                          {new Date(day.date).toLocaleDateString("en-us", {
                            month: "short",
                          })}
                        </span>
                      </div>

                      <span className="storeStock__trading-Hours__openHour">
                        {day.openHour.toLowerCase() !== "closed" ? (
                          <div>
                            <span className="storeStock__trading-Hours__openHour-time">
                              {day.openHour.split("-")[0].toUpperCase()}
                            </span>
                            <span className="storeStock__trading-Hours__openHour-separator">
                              {" "}
                              -
                            </span>
                            <span className="storeStock__trading-Hours__openHour-time">
                              {day.openHour.split("-")[1].toUpperCase()}
                            </span>
                          </div>
                        ) : (
                          "Closed"
                        )}
                      </span>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="message__text--qr">
        <div className="storeStock__button">
          {!store.isSelected && (
            <span
              onClick={onClickHandler}
              className="storeStock__button--select"
              id="store-select-link"
              tabIndex={1}
            >
              Select store
            </span>
          )}
          {store.isSelected && (
            <span className="storeStock__button--selected">
              Selected
              <img
                className="storeStock__selectedImage"
                src="/images/correctWhite.svg"
                alt=""
              />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export { StoreSelectorDetail };
